<template>
  <LyrausTable
    :data="List"
    :columns="columns"
    :innerTable="innerTableColumns"
    :enablePagination="true"
    :isLoading="load"
    :stickyLeft="['orderNo']"
    :stickyRight="$parent.isArchived ? ['buttonsColumn'] : ['dropdownColumnDurum', 'buttonsColumn']"
    :batchOperations="!$parent.isArchived"
    :searchBar="true"
    :searchProp="$parent.search"
    @update-search-value="(val) => $parent.search=val"
    :handleSearch="$parent.handleSearch"
    :alternateRowBg="['white', 'gray-100']"
    :rightExtraSlot="!$parent.isArchived"
    :dblClickableColumns="dblClickableColumns"
    :pageCount="$parent.pageCount"
    :pageProp="$parent.currentPage"
    @update-current-page="$parent.handleCurrentPage"
    :totalCount="$parent.totalCount"
    @dbl-row-click="$parent.handleDblRowClick"
    :buttonsColumn="{ label: 'İşlem', width: 120 }"
    :dropdownColumns="$parent.isArchived ? [] : [{ key: 'Durum', label: 'Durum' }]"
    :paginationButtonColor="'red-600'"
    :paginationHoverColor="'red-700'"
    :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
    :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
    :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
  >
    <template v-slot:searchBar>
      <SearchInput :isFull="true" :value="$parent.search" @searcing="(val) => handleSearch(val)" />
    </template>
    <template v-slot:batchOperations>
      <asyncBtn
        v-if="!$parent.isArchived"
        icon="fas fa-plus"
        :text="$t('operations.planning.newBtnTitle')"
        class="w-36 btn"
        @click="() => $parent.$modal.show('add-plan-modal')"
      />
    </template>
    <template v-slot:rightExtra>
      <div v-if="!$parent.isArchived" class="flex items-center">
        <!-- Tarih Filtresi -->
        <div class="relative" @mousedown.stop>
          <button
            class="h-11 w-14 bg-white shadow ml-2 mr-2 rounded-lg justify-center items-center flex"
            :class="($parent.startDate && $parent.endDate) ? 'ring-2 ring-blue-400' : ''"
            @mousedown.stop="showDateFilter = !showDateFilter"
          >
            <i v-if="!showDateFilter" class="fas fa-calendar-alt text-gray-600"></i>
            <i v-else class="fas fa-times text-red-700 font-bold text-xl"></i>
          </button>
          <div
            @mousedown.stop="showDateFilter = true"
            :class="{ 'invisible opacity-0': !showDateFilter }"
            class="absolute right-0 mt-2 z-50 bg-white border border-gray-300 rounded-lg shadow-md p-3 transition-all ease-in duration-100"
            style="width: 280px"
          >
            <p class="text-xs font-semibold text-gray-600 mb-2">Tarih Filtresi</p>
            <div class="flex mb-2 rounded-lg overflow-hidden border border-gray-200">
              <button
                @click="$parent.dateType = 'filling'"
                class="flex-1 px-3 py-1.5 text-xs font-medium transition-colors"
                :class="$parent.dateType === 'filling' ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-50'"
              >
                <i class="fas fa-fill-drip mr-1"></i>Dolum
              </button>
              <button
                @click="$parent.dateType = 'delivery'"
                class="flex-1 px-3 py-1.5 text-xs font-medium transition-colors"
                :class="$parent.dateType === 'delivery' ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-50'"
              >
                <i class="fas fa-truck mr-1"></i>Teslim
              </button>
            </div>
            <div class="space-y-2 mb-3">
              <div>
                <label class="text-xxs text-gray-500">Başlangıç</label>
                <input type="date" v-model="$parent.startDate" class="w-full border border-gray-200 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-400" />
              </div>
              <div>
                <label class="text-xxs text-gray-500">Bitiş</label>
                <input type="date" v-model="$parent.endDate" class="w-full border border-gray-200 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-400" />
              </div>
            </div>
            <div class="flex gap-2">
              <button
                @click="applyDateFilter"
                class="flex-1 py-1.5 text-xs font-medium rounded transition-colors"
                :class="$parent.startDate && $parent.endDate ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-100 text-gray-400 cursor-not-allowed'"
                :disabled="!$parent.startDate || !$parent.endDate"
              >
                <i class="fas fa-check mr-1"></i>Uygula
              </button>
              <button
                v-if="$parent.startDate || $parent.endDate"
                @click="clearDateFilter"
                class="py-1.5 px-3 text-xs font-medium rounded text-red-500 hover:bg-red-50 border border-red-200 transition-colors"
              >
                <i class="fas fa-times mr-1"></i>Temizle
              </button>
            </div>
          </div>
        </div>

        <userFilterModal
          ref="modalActive"
          :selectedItems="$parent.selectedItems"
          :load="load"
          @selected-items-changed="$parent.handleSelectedItemsChanged"
        />
      </div>
    </template>
    <template v-slot:colDropdown="{ item, dropdownKey }">
      <div
        v-if="dropdownKey === 'dropdownColumnDurum'"
        class="table-td w-36 border-r border-opacity-20"
      >
        <changeStatus
          :statusList="$parent.statusList"
          :plaque="item.vehicle"
          :defaultTitle="item.stateName"
          :stateId="item.stateId"
          :typeId="item.typeId"
          :planId="item.id"
          :orderNo="item.orderNo"
          :note="item.notes"
          :item="item"
          @changeVehicle="
            () => ((selected = item),$emit('changeSelected',item), $parent.$modal.show('change-vehicle-modal'))
          "
          @isSameVehicle="(val)=>$emit('isSameVehicle',val)"
          @refresh="() => $parent.getAll()"
          @vehicleStatu="
            (r) => (
              ($parent.$refs.vehicleStatu.modalData = {
                detail: item,
                activeStatu: r,
              }),
              $parent.$refs.vehicleStatu.show()
            )
          "
        />
      </div>
    </template>
     <!-- Sort Buttons -->
     <template v-slot:sortButton="{ columnKey }">
      <!-- Search Clear Button -->
      <div
        v-if="columnKey === $parent.searchColumn"
        @click="$parent.clearSearch()"
        class="cursor-pointer mr-1"
      >
        <i class="fas fa-times text-red-600"></i>
      </div>

      <!-- Sorting Buttons for Different Columns -->
      <sort-button
        :column-key="columnKey"
        :sort-column="$parent.sortColumn"
        :sort-state="$parent.sortState"
        @toggle-sort="(column) => $parent.toggleSort(column)"
      />
    </template>

    <template v-slot:colButtons="{ item }">
      <div class="flex items-center justify-end px-2">
        <button class="mr-2" @click="$parent.noteDetailModal(item)">
          <i class="far fa-sticky-note"></i>
        </button>
      </div>

      <div class="flex items-center justify-end px-2">
        <button class="mr-2 relative" @click="$parent.showEditModal(item)">
          <i
            :class="item.stateId >= 8 && 'text-gray-700 text-opacity-50'"
            class="fas fa-pen"
          ></i>
          <i
            v-if="item.explanation"
            class="fas fa-circle text-xxs absolute -left-2 -top-1 text-red-600 animate-pulse"
          ></i>
        </button>
      </div>

      <div class="flex items-center justify-end px-2">
        <button
          class="mr-2"
          :class="item.isError > 0 ? 'animated animate-pulse duration-200' : ''"
          @click="$parent.vehicleStatesModel(item)"
        >
          <i
            class="fas fa-search"
            :class="
              item.isError > 0
                ? 'text-red-500 animate-pulse duration-200'
                : 'text-gray-700'
            "
          ></i>
        </button>
      </div>

      <div class="flex items-center justify-end px-2">
        <button
          :disabled="item.stateId == 8 || item.stateId == 10"
          :class="item.stateId >= 8 && ' bg-opacity-70 mr-2'"
          class="mr-2"
          @click="$parent.deleteItem(item)"
        >
          <i
            :class="
              (item.stateId == 8 || item.stateId == 10) &&
              'text-gray-400 text-opacity-50 '
            "
            class="fas fa-trash text-gray-700"
          ></i>
        </button>
      </div>
    </template>
    <template v-slot:rowButtons="{ item, columnKey }">
      <div v-if="columnKey === 'reservation'" class="flex items-center justify-center">
        <div v-if="item.isReserved && !item.taskSent" class="group relative">
          <div class="flex items-center space-x-1 px-2 py-1 rounded-full bg-orange-100 dark:bg-orange-900 border border-orange-300 dark:border-orange-700">
            <i class="far fa-clock text-orange-600 dark:text-orange-400 text-xs"></i>
            <span class="text-xs font-semibold text-orange-700 dark:text-orange-300">Beklemede</span>
          </div>
          <div class="absolute bottom-full left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs rounded py-1 px-2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
            Rezervasyon: {{ formatDateTime(item.scheduledNotificationTime) }}
          </div>
        </div>
        <div v-else-if="item.isReserved && item.taskSent" class="flex items-center space-x-1 px-2 py-1 rounded-full bg-green-100 dark:bg-green-900 border border-green-300 dark:border-green-700">
          <i class="fas fa-check text-green-600 dark:text-green-400 text-xs"></i>
          <span class="text-xs font-semibold text-green-700 dark:text-green-300">Gönderildi</span>
        </div>
        <span v-else class="text-xs text-gray-400">-</span>
      </div>
      <div
        v-if="columnKey === 'vehicle'"
        class="flex items-center justify-between"
      >
        <p
          @click="item.vehicle ? $parent.handleItemClick(item) : ''"
          :class="
            item.stateId >= 8 ? 'opacity-40' : 'cursor-pointer select-none'
          "
          class="border rounded-lg p-1 justify-between"
        >
          {{ item.vehicle }}
          <i class="fas fa-search text-gray-700"></i>
        </p>
        <div class="ml-2 flex items-center justify-between">
          <span
            @click="swalBox('info','BİLGİ',item.isPirateDriver == 1 ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı' : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti')"
            style="font-size: 11px"
            class="px-2 mr-2  rounded-xl cursor-pointer select-none text-white inline-block font-extralight"
            :class="item.isPirateDriver == 1 ? 'bg-yellow-600' : 'bg-red-600'"
            v-if="item.isCustom == 1 || item.isPirateDriver == 1"
            :title="item.isPirateDriver == 1 ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı' : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti'"
          >
            <i class="fas fa-info-circle    "></i>
            {{ item.isPirateDriver == 1 ? "Korsan Atama" : "Manuel Atama" }}
          </span>
        </div>
      </div>
    </template>
    <template v-slot:filterButton="{ columnKey }">
      <statusPanel
        v-if="columnKey === 'dropdownColumnDurum' && !$parent.isArchived"
        @stopFiltering="() => $parent.stopFiltering()"
        :statusId="$parent.statusId"
        :initialStatus="$parent.statusId"
        :statusList="status"
        @setStatusFilter="(val) => $parent.setStatusFilter(val)"
      />
    </template>
  </LyrausTable>
</template>

<script>
import SearchInput from "@/components/general/search-input.vue";
import statusPanel from "@/components/filters/filterTableStatus/index.vue";
import changeStatus from "../../components/change/status.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import userFilterModal from "@/components/filters/userFiltering/index.vue";
import sortButton from './SortButton.vue'
import { planningStatus } from "@/utils/statusName";
import moment from 'moment';
export default {
  name: "planning-table",
  props:["List","load","pageCount"],
  components:{
    changeStatus,
    asyncBtn,
    userFilterModal,
    statusPanel,
    sortButton,
    SearchInput
  },
  computed: {
    columns() {
      const cols = [
        {
          key: "orderNo",
          label: "#",
        },
        {
          key: "customer",
          label: "Müşteri",
          maxLength: 18,
        },
        {
          key: "receivedName",
          label: "Dolum",
          maxLength: 18,
        },
        {
          key: "deliveredName",
          label: "Teslim",
          maxLength: 18,
        },
        {
          key: "productType",
          label: "Ürün",
        },
        {
          key: "vehicle",
          label: "Araç",
          dontDisplay: true,
        }
      ];
      if (this.$parent.isArchived) {
        cols.push({
          key: "stateName",
          label: "Durum",
        });
      }
      return cols;
    },
  },
  data() {
    return {
      dblClickableColumns: [
        "customer",
        "receivedName",
        "deliveredName",
        "productType",
      ],
      innerTableColumns: [
        { key: "orderName", label: "Kaynak" },
        { key: "outpointAdress", label: "Dolum Adresi" },
        { key: "targetAdress", label: "Teslim Adresi" },
        { key: "invoicedCompany", label: "Fatura Adresi" },
        { key: "deliveryDate", label: "Teslim Tarihi", isDate: true },
        { key: "driver", label: "Sürücü" },
        { key: "tourRecord", label: "Sefer Kaydı" },
      ],
      order: [
        {
          orderId: 1,
          orderName: "A-Z Sırala",
          active: false,
        },
        {
          orderId: 2,
          orderName: "Z-A Sırala",
          active: false,
        },
        {
          orderId: 0,
          orderName: "Varsayılan Sıralama",
          active: false,
        },
      ],
      showDateFilter: false,
      status:planningStatus
    };
  },
  methods:{
    formatDateTime(datetime) {
      if (!datetime) return '-';
      return moment(datetime).format('DD.MM.YYYY HH:mm');
    },
    handleSearch(val){
      this.$parent.search=val;
      this.$parent.handleSearch();
    },
    applyDateFilter() {
      this.$parent.currentPage = 0;
      this.$parent.getAll();
      this.showDateFilter = false;
    },
    clearDateFilter() {
      this.$parent.startDate = "";
      this.$parent.endDate = "";
      this.$parent.currentPage = 0;
      this.$parent.getAll();
      this.showDateFilter = false;
    }
  }
};
</script>

